import type { ReactNode } from 'react';

export const fallbackValueFormatter = (value: ReactNode): ReactNode => value ?? '—';
